import { AccessControlAction, SET_ACLS, SET_GROUPED_ACLS_BY_USER } from '@Actions/accessControlActions';

import { IAccessControlListModel } from '@Shared/models';

interface IAccessControlState {
  nonApprovalAcls: IAccessControlListModel[];
  coexpensingAcls: IAccessControlListModel[];
  groupedAclsByUser: any;
}

export const defaultState: IAccessControlState = {
  nonApprovalAcls: [],
  coexpensingAcls: [],
  groupedAclsByUser: null
};

export function accessControlReducer(state = defaultState, action: AccessControlAction): IAccessControlState {
  switch (action.type) {
    case SET_ACLS: {
      return {
        ...state,
        nonApprovalAcls: action.payload.filter((acl) => acl.access_type === 'user_profile.non_approval'),
        coexpensingAcls: action.payload.filter((acl) => acl.access_type === 'linked_account.coexpensing')
      };
    }
    case SET_GROUPED_ACLS_BY_USER: {
      return {
        ...state,
        groupedAclsByUser: action.payload
      };
    }
    default:
      return state;
  }
}
